import React from 'react';
import PropTypes from 'prop-types';

import ProductInstagramGrid from '../ProductInstagramGrid/ProductInstagramGrid';
import { IconHeart, IconMaterial, IconCare, IconSize, IconExpertTips, IconFreeShipping } from '../Icons';
import { ProductDetailsWrapper, StyledContentWrapper, StyledUl, StyledLi, StyledDescriptionDiv } from './ProductDetailsStyles';

var removeHTMLTags = function removeHTMLTags(html) {
  return html.replace(/<\/?[^>]+(>|$)/g, '');
};

var _ref = React.createElement(ProductInstagramGrid, null);

var _ref2 = React.createElement(
  'h6',
  null,
  'Details'
);

var _ref3 = React.createElement(IconHeart, null);

var _ref4 = React.createElement(IconMaterial, null);

var _ref5 = React.createElement(IconCare, null);

var _ref6 = React.createElement(IconSize, null);

var _ref7 = React.createElement(IconExpertTips, null);

var _ref8 = React.createElement(
  StyledLi,
  { shippingSurcharge: true },
  React.createElement(IconFreeShipping, null),
  React.createElement(
    'span',
    null,
    'Due to the size and weight of this product, it needs a little extra care. Additional shipping cost will be incurred at checkout.'
  )
);

var _ref9 = React.createElement(
  'h6',
  null,
  'Description'
);

var ProductDetails = function ProductDetails(props) {
  return React.createElement(
    ProductDetailsWrapper,
    { bundle: props.bundle },
    _ref,
    React.createElement(
      StyledContentWrapper,
      { bundle: props.bundle },
      React.createElement(
        'div',
        null,
        _ref2,
        React.createElement(
          StyledUl,
          { bundle: props.bundle },
          props.whyWeLove && React.createElement(
            StyledLi,
            null,
            _ref3,
            React.createElement(
              'span',
              null,
              removeHTMLTags(props.whyWeLove.value)
            )
          ),
          props.material && React.createElement(
            StyledLi,
            null,
            _ref4,
            React.createElement(
              'span',
              null,
              removeHTMLTags(props.material.value)
            )
          ),
          props.care && React.createElement(
            StyledLi,
            null,
            _ref5,
            React.createElement(
              'span',
              null,
              removeHTMLTags(props.care.value),
              props.careLongText && React.createElement(
                'a',
                { href: '/pages/care#' + props.careLongText.value },
                ' ',
                'Additional Instructions.'
              )
            )
          ),
          props.dimension && React.createElement(
            StyledLi,
            null,
            _ref6,
            React.createElement(
              'span',
              null,
              removeHTMLTags(props.dimension.value)
            )
          ),
          props.expertTips && React.createElement(
            StyledLi,
            null,
            _ref7,
            React.createElement(
              'span',
              null,
              removeHTMLTags(props.expertTips.value)
            )
          ),
          props.shippingSurcharge && _ref8
        )
      ),
      props.descriptionHtml && React.createElement(
        'div',
        null,
        _ref9,
        React.createElement(StyledDescriptionDiv, {
          bundle: props.bundle,
          dangerouslySetInnerHTML: { __html: props.descriptionHtml }
        })
      )
    )
  );
};

ProductDetails.propTypes = {
  whyWeLove: PropTypes.object,
  care: PropTypes.object,
  careLongText: PropTypes.object,
  expertTips: PropTypes.object,
  material: PropTypes.object,
  dimension: PropTypes.object,
  descriptionHtml: PropTypes.string,
  bundle: PropTypes.bool,
  shippingSurcharge: PropTypes.bool
};

export default React.memo(ProductDetails);